// extracted by mini-css-extract-plugin
export var divider = "_sk-0";
export var systemMessage = "_sk-1";
export var systemMessageWrapper = "_sk-2";